import { render } from "./ResetPasswordEmailPage.vue?vue&type=template&id=6fd1d14c"
import script from "./ResetPasswordEmailPage.vue?vue&type=script&lang=js"
export * from "./ResetPasswordEmailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__